import React from 'react';
import { useNavigate } from 'react-router-dom';

const IndustryAcademicPanel = () => {
  const navigate = useNavigate();

  return (
    <div className="startup-showcases-page">
      {/* Header Section */}
      <div className="page-header">
        <div className="container">
          <button className="back-button" onClick={() => navigate(-1)}>
            <i className="fas fa-arrow-left"></i> Back to AgConverge
          </button>
          <div className="header-content">
            <div className="icon-large">🎓</div>
            <h1>Industry Academic Panel</h1>
            <p className="subtitle">Building bridges between research and industry</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="content-card">
            <h2>About</h2>
            <p>
              The Industry-Academia Panel brings together voices from across the ag innovation
              ecosystem (a grower, industry leaders, and an academic), to talk about what it takes
              to make collaboration work. Each group brings something unique: universities generate
              ideas and research, companies scale those ideas into real products, and farmers test
              whether they actually work on the ground. The goal is to explore how we can work
              together more effectively to move technologies from the lab to the field, train the
              next generation of talent, and create solutions that make sense both economically and
              practically for farmers and businesses alike. We'll learn from what's working, what
              isn't, and identify practical ways to build a stronger workforce while creating impact
              and economic value that benefits both producers and industry.
            </p>
          </div>

          {/* Objectives Section */}
          <div className="content-card">
            <h2>Objectives</h2>
            <p>Discussion will highlight how academia, growers and industry can:</p>
            <ul style={{ marginLeft: '20px', marginTop: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                Align research priorities, workforce training, and curriculum design with real
                industry and grower needs.
              </li>
              <li style={{ marginBottom: '10px' }}>
                Align industry R&D priorities with academic research and grower needs.
              </li>
              <li style={{ marginBottom: '10px' }}>
                Highlight examples of effective partnerships between universities, research
                institutes, and the private sector.
              </li>
              <li style={{ marginBottom: '10px' }}>
                Identify practical solutions around IP, contracting, and cost-sharing that
                limit collaboration.
              </li>
              <li style={{ marginBottom: '10px' }}>
                Advance workforce readiness and build experiential learning models through
                internships, and joint certifications.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IndustryAcademicPanel;